var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container feedback template-bg-gray" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec" },
        [
          _c(
            "div",
            {
              staticClass:
                "loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "div",
                {
                  staticClass: "card form-wrapper",
                  class: { thankupageplr88: !_vm.isBeforRequest }
                },
                [
                  _c(
                    "div",
                    { staticClass: "feedback_container" },
                    [
                      _c("div", { staticClass: "community-logo" }, [
                        this.hasLogo
                          ? _c("img", {
                              staticClass: "top-logo custom-logo",
                              attrs: {
                                src: _vm.community.customSettings.logoURL,
                                alt: _vm.community.content.parameter2
                                  ? _vm.community.content.parameter2
                                  : "Community Logo"
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      this.isBeforRequest
                        ? [
                            _c(
                              "h1",
                              {
                                staticClass:
                                  "template-title my-text-center common-space-from-logo mb35"
                              },
                              [_vm._v("Send a message")]
                            ),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass: "template-form",
                                attrs: {
                                  autocomplete: "off",
                                  "data-vv-scope": "email-form"
                                },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.save("email-form")
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-6 mb-17" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "label",
                                        { staticClass: "template-label" },
                                        [_vm._v("Your Email Address")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "required-symbol" },
                                        [_vm._v(" *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          { name: "focus", rawName: "v-focus" },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.advice.from_email,
                                            expression: "advice.from_email"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.continues",
                                            value: "required|email",
                                            expression: "'required|email'",
                                            modifiers: { continues: true }
                                          }
                                        ],
                                        staticClass:
                                          "form-control input-value pt-input input-focus",
                                        class: {
                                          "request-form-error-border": _vm.errors.has(
                                            "email-form.from_email"
                                          )
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "from_email",
                                          "aria-label": "Your Email Address",
                                          name: "from_email",
                                          placeholder:
                                            "What's your email address?"
                                        },
                                        domProps: {
                                          value: _vm.advice.from_email
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.advice,
                                                "from_email",
                                                $event.target.value
                                              )
                                            },
                                            function(e) {
                                              return (_vm.advice.from_email = _vm.sanitizeInput(
                                                e.target.value
                                              ))
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "email-form.from_email"
                                              ),
                                              expression:
                                                "errors.has('email-form.from_email')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "email-form.from_email"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-6 mb-17 mr-1" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "template-label" },
                                            [_vm._v("Email")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "required-symbol" },
                                            [_vm._v(" *")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.advice.email,
                                                expression: "advice.email"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate.continues",
                                                value: "required|email",
                                                expression: "'required|email'",
                                                modifiers: { continues: true }
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-value pt-input input-focus",
                                            class: {
                                              "request-form-error-border": _vm.errors.has(
                                                "email-form.email"
                                              )
                                            },
                                            attrs: {
                                              type: "text",
                                              id: "email",
                                              "aria-label": "Email",
                                              name: "email",
                                              placeholder: ""
                                            },
                                            domProps: {
                                              value: _vm.advice.email
                                            },
                                            on: {
                                              input: [
                                                function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.advice,
                                                    "email",
                                                    $event.target.value
                                                  )
                                                },
                                                function(e) {
                                                  return (_vm.advice.email = _vm.sanitizeInput(
                                                    e.target.value
                                                  ))
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "email-form.email"
                                                  ),
                                                  expression:
                                                    "errors.has('email-form.email')"
                                                }
                                              ],
                                              staticClass: "error"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "email-form.email"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.advice.subject,
                                            expression: "advice.subject"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass:
                                          "form-control input-value pt-input w-100 input-focus",
                                        class: {
                                          "request-form-error-border": _vm.errors.has(
                                            "email-form.subject"
                                          )
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "subject",
                                          placeholder:
                                            "Please enter a subject line for your request",
                                          "aria-label": "Email Subject",
                                          name: "subject"
                                        },
                                        domProps: { value: _vm.advice.subject },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.advice,
                                                "subject",
                                                $event.target.value
                                              )
                                            },
                                            function(e) {
                                              return (_vm.advice.subject = _vm.sanitizeInput(
                                                e.target.value
                                              ))
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "email-form.subject"
                                              ),
                                              expression:
                                                "errors.has('email-form.subject')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "email-form.subject"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12 mt-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2"
                                      },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate.continues",
                                              value: "required|max:2000",
                                              expression: "'required|max:2000'",
                                              modifiers: { continues: true }
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.advice.message,
                                              expression: "advice.message"
                                            }
                                          ],
                                          staticClass:
                                            "form-control request-form-question-textarea",
                                          class: {
                                            "request-form-error-border": _vm.errors.has(
                                              "message"
                                            )
                                          },
                                          attrs: {
                                            name: "message",
                                            rows: "5",
                                            maxlength: _vm.max,
                                            placeholder: "Your message here"
                                          },
                                          domProps: {
                                            value: _vm.advice.message
                                          },
                                          on: {
                                            keyup: _vm.countdown,
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.advice,
                                                  "message",
                                                  $event.target.value
                                                )
                                              },
                                              function(e) {
                                                return (_vm.advice.message = _vm.sanitizeInput(
                                                  e.target.value
                                                ))
                                              }
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group pd-remove unsubscribe-btn mb-0-custom"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "char-counter template-subject-counter",
                                                class: {
                                                  "char-count-error":
                                                    _vm.exceedsMaxCount
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.remainingCount) +
                                                    "  / 2000"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "email-form.message"
                                            ),
                                            expression:
                                              "errors.has('email-form.message')"
                                          }
                                        ],
                                        staticClass: "error"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              "email-form.message"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "btn-block text-right mlr0" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "btn btn_info template-review-submit template-button template-button-width mlr0",
                                        style: _vm.reviewBtn,
                                        attrs: {
                                          type: "submit",
                                          name: "helpAction"
                                        }
                                      },
                                      [_vm._v("Send")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "my", attrs: { id: "tips" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "box-sub-heading custom-content my-text-center"
                                      },
                                      [
                                        _vm._v(
                                          "Not sure how to ask? Read our\n                                    "
                                        ),
                                        _vm.community.content &&
                                        _vm.community.content.tips &&
                                        _vm.community.content.tips.length
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "text-underline",
                                                attrs: {
                                                  tabindex: "0",
                                                  href:
                                                    _vm.community.content.tips,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v("tips")]
                                            )
                                          : _c("span", [_vm._v("tips")]),
                                        _vm._v(
                                          ".\n                                    "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        : [_vm._m(1)]
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-inline text-center footer-links" },
                [
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.landingPageURL &&
                    _vm.community.content.landingPageURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.landingPageURL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [_vm._v("Learn More")]
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)", tabindex: "0" }
                          },
                          [_vm._v("Learn More")]
                        )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.termsConditionsURL &&
                    _vm.community.content.termsConditionsURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.termsConditionsURL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [_vm._v("Terms Of Use")]
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)", tabindex: "0" }
                          },
                          [_vm._v("Terms Of Use")]
                        )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.unsubscribePageURL &&
                    _vm.community.content.unsubscribePageURL.length
                      ? _c(
                          "a",
                          {
                            attrs: {
                              tabindex: "0",
                              href: _vm.community.content.unsubscribePageURL,
                              target: "_blank"
                            }
                          },
                          [_vm._v("Opt Out")]
                        )
                      : _c("a", { attrs: { href: "javascript:void(0)" } }, [
                          _vm._v("Opt Out")
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unsubscribe-community-logo" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "https://www.protopia.co", target: "_blank" }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.logoURL, alt: "Community Logo" }
                    })
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "template-label" }, [
      _vm._v("Email Subject "),
      _c("span", { staticClass: "required-symbol" }, [_vm._v(" *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "header-text text-center unsubscribepage-thankumsg" },
      [
        _c("h1", { staticClass: "template-title common-space-from-logo" }, [
          _vm._v("Thank you!")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2f60e54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f60e54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Communication.vue
// module id = null
// module chunks = 